import * as React from 'react';
import { Button } from 'reactstrap';
import { IButtonClickable } from './types';

const CancelIconButton: React.FC<IButtonClickable> = (props) => {

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {

    props.onClick(event);
  
  };
  return (
    <Button color="info" onClick={handleClick} className="text-white"><i title="back" className="fa fa-2x fa-arrow-left" /></Button>
  );

};

export default CancelIconButton;
